"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var components_1 = require("@athena-portal/components");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../../Types");
var DeceasedCustomerAction = /** @class */ (function (_super) {
    __extends(DeceasedCustomerAction, _super);
    function DeceasedCustomerAction(props) {
        var _this = _super.call(this, props) || this;
        _this.markAsDeceased = function () {
            _this.supportPortalService.markAsDeceased(_this.props.customerReferenceNumber).subscribe(function () {
                location.reload();
            });
            _this.supportPortalService.logAgentActivity(_this.props.customerReferenceNumber, { "action": "Flag as deceased", "customer": "Account" }).subscribe();
        };
        _this.state = {
            policyVersion: null
        };
        _this.markAsDeceased = _this.markAsDeceased.bind(_this);
        return _this;
    }
    DeceasedCustomerAction.prototype.componentDidMount = function () {
        var _this = this;
        if (this.props.customerReferenceNumber && this.props.policyNumber && this.props.policyVersionNumber) {
            this.supportPortalService
                .getPolicyVersionDetails(this.props.customerReferenceNumber, this.props.policyNumber, this.props.policyVersionNumber)
                .pipe().subscribe(function (policyVersion) {
                _this.setState({ policyVersion: policyVersion });
            });
        }
    };
    DeceasedCustomerAction.prototype.render = function () {
        if (this.state.policyVersion) {
            var interactionId = this.state.policyVersion.interactionId;
            return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { className: "d-block text-primary", to: ("/journey/show/product/PropositionWolfMotorInsurance/process/mtcSupportPortalAnnualDeceased/cancellationReasonPolicy/".concat(interactionId)), children: "Flag as deceased" }) }));
        }
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], DeceasedCustomerAction.prototype, "supportPortalService", void 0);
    DeceasedCustomerAction = __decorate([
        components_1.authorize,
        (0, components_1.role)("Administrator", "CSR_Lead", "CSR", "Fraud"),
        __metadata("design:paramtypes", [Object])
    ], DeceasedCustomerAction);
    return DeceasedCustomerAction;
}(React.Component));
exports.default = DeceasedCustomerAction;
//# sourceMappingURL=DeceasedCustomerAction.js.map